import { createEntitySlice } from '~/utils/slices/createEntitySlice'

import type { ProductVariant } from '../@types'

const useProductVariantsSlice = createEntitySlice<ProductVariant>({
  name: 'productVariants',
})

export default useProductVariantsSlice
